/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_To_CsvInputs */

const en_sidebar_to_csv = /** @type {(inputs: Sidebar_To_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → CSV`)
};

const ko_sidebar_to_csv = /** @type {(inputs: Sidebar_To_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → CSV`)
};

const ja_sidebar_to_csv = /** @type {(inputs: Sidebar_To_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → CSV`)
};

/**
* | output |
* | --- |
* | "JSON → CSV" |
*
* @param {Sidebar_To_CsvInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_to_csv = /** @type {((inputs?: Sidebar_To_CsvInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_To_CsvInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_to_csv(inputs)
	if (locale === "ko") return ko_sidebar_to_csv(inputs)
	return ja_sidebar_to_csv(inputs)
});